/* eslint-disable no-template-curly-in-string*/
const typeTemplate = '${label}は有効な ${type} 型ではありません。'

export const validateMessages = {
  default: '${label}でバリデーションエラーが発生しました。',
  required: '${label}は必須です。',
  enum: '${label}は必ず [${enum}] の中から一つ選んでください。',
  whitespace: '${label}は空欄には出来ません。',
  date: {
    format: '${label}は有効な日付フォーマットではありません。',
    parse: '${label}を日付にパースできません。',
    invalid: '${label}は有効な日付ではありません。',
  },
  types: {
    string: typeTemplate,
    method: typeTemplate,
    array: typeTemplate,
    object: typeTemplate,
    number: typeTemplate,
    date: typeTemplate,
    boolean: typeTemplate,
    integer: typeTemplate,
    float: typeTemplate,
    regexp: typeTemplate,
    email: typeTemplate,
    url: typeTemplate,
    hex: typeTemplate,
  },
  string: {
    len: '${label}は必ず${len}文字入力してください。',
    min: '${label}は${min}文字以上入力してください。',
    max: '${label}は${max}文字以上入力できません。',
    range: '${label}は${min}文字から${max}文字の間で入力してください。',
  },
  number: {
    len: '${label}は${len}と一致するしなければいけません。',
    min: '${label}は${min}より小さい値にはできません。',
    max: '${label}は${max}より大きい値にはできません。',
    range: '${label}は${min}から${max}の範囲の値を入力してください。',
  },
  array: {
    len: '${label}は必ず${len}個入力してください。',
    min: '${label}は${min}より少ない数は出来ません。',
    max: '${label}は${max}より多い数には出来ません。',
    range: '${label}は必ず${min}から${max}の範囲の値を入力してください。',
  },
  pattern: {
    mismatch: '${label}が${pattern}パターンと一致しません。',
  },
}
